import { ApiConfig, HttpService, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { MS_PER_MINUTE } from '@skylab-shared/utils';
import { ReportPrintQuery, ReportPrintQueryParameters, ReportPrintResult } from '../queries/report-print.query-base';

export interface BalanceSheetPrintResult extends ReportPrintResult { }

export interface BalanceSheetPrintParameters extends ReportPrintQueryParameters { }

export class BalanceSheetPrintQuery extends ReportPrintQuery<BalanceSheetPrintResult> {
    public constructor(
        public override readonly parameters: BalanceSheetPrintParameters
    ) {
        super(parameters);
    }
}

export class BalanceSheetPrintQueryHandlerBase implements QueryHandler<BalanceSheetPrintQuery, BalanceSheetPrintResult> {
    private static Url = TaggedUrl.join('balance/printing', [Tags.Api]);

    public constructor(private readonly http: HttpService) {}

    public async handleAsync({ parameters }: BalanceSheetPrintQuery): Promise<BalanceSheetPrintResult> {
        const requestData = {
            compress: parameters.compress,
            password: parameters.password,
            ecoMode: parameters.ecoMode,
            landscape: parameters.landscape,
            config: {
                parameters: JSON.stringify(parameters.parameters),
                summary: parameters.summary,
                columns: parameters.columns,
                report: 'Bilans'
            }
        };

        const { data } = await this.http.post<{ url: string; }>(BalanceSheetPrintQueryHandlerBase.Url, requestData, {timeout: 3 * MS_PER_MINUTE });

        return {
            url: `${ApiConfig.baseUrl}${data.url}`
        };
    }
}
